import { createStore } from 'vuex'
import auth from '@/modules/auth/store/index'
import admin from '@/modules/admin/store/index'

const storageKey = 'showMenu';

export default createStore({
  state: {
    showMenu: localStorage.getItem(storageKey) === 'true'
  },
  mutations: {
    menuToggle(state){
      state.showMenu = !state.showMenu;
      localStorage.setItem(storageKey, state.showMenu);
      return state.showMenu;
    },
    closeMenu(state){
      state.showMenu = false;
      localStorage.setItem(storageKey, state.showMenu);
      return state.showMenu;
    }
  },
  actions: {
    toggleMenuState({commit}){
      commit('menuToggle')
    },
    menuClose({commit}){
      commit('closeMenu')
    }
  },
  getters: {
    getMenuState(state){
      return state.showMenu;
    }
  },
  modules: {
    auth,
    admin
  }
})
